import { useState, useRef, useEffect, Dispatch, SetStateAction } from "react";
import "./Caroussel.css";
import { ArrowForwardIcon } from "@chakra-ui/icons";

interface CarousselScrollavelProps {
  imagens: string[];
  setIsBtnDisabled: Dispatch<SetStateAction<boolean>>;
}

export default function Caroussel({
  imagens,
  setIsBtnDisabled,
}: CarousselScrollavelProps) {
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    setActiveIndex(0);
    setIsBtnDisabled(true);
  }, [imagens]);

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer || imagens.length === 0) return;

    requestAnimationFrame(() => {
      scrollContainer.scrollTo({
        left: 0,
        behavior: "auto",
      });
    });
    const handleScroll = () => {
      const scrollPosition = scrollContainer.scrollLeft;
      const itemWidth = scrollContainer.offsetWidth;
      const newIndex = Math.round(scrollPosition / itemWidth);

      if (newIndex !== activeIndex) {
        setActiveIndex(newIndex);
      }
    };

    scrollContainer.addEventListener("scroll", handleScroll);

    return () => scrollContainer.removeEventListener("scroll", handleScroll);
  }, [imagens]);

  const scrollTo = (index: number) => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTo({
        left: index * scrollContainerRef.current.offsetWidth,
        behavior: "smooth",
      });
    }
  };

  const handleScrollToRight = () => {
    if (activeIndex < imagens.length - 1) {
      return scrollTo(activeIndex + 1);
    }
  };

  useEffect(() => {
    if (activeIndex === imagens.length - 1) {
      setIsBtnDisabled(false);
    }
  }, [activeIndex, imagens]);

  return (
    <div className="carrossel-container">
      <div ref={scrollContainerRef} className="carrossel-scroll">
        {imagens.length > 0 &&
          imagens.map((src, index) => (
            <div key={index} className="carrossel-item">
              <img src={src} alt={`Imagem ${index + 1}`} className="carrossel-imagem" />
            </div>
          ))}
      </div>

      <div className="carrossel-arrow-forward">
        <button onClick={handleScrollToRight}>
          <ArrowForwardIcon fontSize={37} color={"white"} />
        </button>
      </div>
      <div className="carrossel-indicadores">
        {imagens.map((_, index) => {
          if (index < 3) {
            return (
              <button
                key={index}
                className={`carrossel-indicador ${index === activeIndex ? "ativo" : ""}`}
                onClick={() => scrollTo(index)}
              />
            );
          } else if (index === 3) {
            return <div key={index} className="carrossel-dash" />;
          }
          return null;
        })}
      </div>
    </div>
  );
}
